const translation = {
  GREETINGS: 'Hello I am',
  MY_NAME: 'Fakhreddine Messaoudi',
  PROFFENCY: 'Full Stack Developer',
  DOWNLOAD_RESUME_BTN: 'Download Resume',
  CONTACT_BTN: `Let's Talk`,
  SCROLL_DOWN: 'Scroll Down'
};

export default translation;
